<input-color-picker
  [label]="to.label"
  [value]="formControl.value"
  (valueChange)="onColorChange($event)"
/>
